import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tile" }
const _hoisted_2 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = ["src", "title"]

import { ref, computed, onMounted, watch, onBeforeUnmount } from "vue";
import * as pbi from "powerbi-client";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportPage',
  props: {
  link: String,
  name: String,
},
  setup(__props) {

const props = __props;

const isLoading = ref(true);
const hasError = ref(false);
const powerbiContainer = ref<HTMLDivElement | null>(null);
let powerbiReport: pbi.Report | null = null;

const isPowerBIReport = computed(() => {
  return (
    props.link?.includes("powerbi.com") ||
    props.link?.includes("app.powerbi.com") ||
    props.link?.includes("powerbi")
  );
});

const embedPowerBIReport = async () => {
  if (!props.link) {
    hasError.value = true;
    isLoading.value = false;
    return;
  }

  try {
    isLoading.value = false; // Set to false first so the container renders
    hasError.value = false;

    // Wait for next tick to ensure the container is rendered
    await new Promise((resolve) => setTimeout(resolve, 0));

    if (!powerbiContainer.value) {
      console.error("Power BI container is not available after rendering");
      hasError.value = true;
      return;
    }

    // For Power BI reports with authentication handled by iframe,
    // we'll use the iframe approach with URL parameters instead of SDK
    // This avoids the token requirement while still hiding sensitivity labels

    let embedUrl = props.link;

    // Add URL parameters to hide sensitivity label and customize UI
    const params = new URLSearchParams();
    params.set("disableSensitivityBanner", "true");

    if (embedUrl.includes("?")) {
      embedUrl += "&" + params.toString();
    } else {
      embedUrl += "?" + params.toString();
    }

    // Create an iframe dynamically
    const iframe = document.createElement("iframe");
    iframe.src = embedUrl;
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.style.border = "none";
    iframe.style.height = "calc(100vh - 100px)";
    iframe.setAttribute("allowfullscreen", "true");

    // Clear previous content
    powerbiContainer.value.innerHTML = "";
    powerbiContainer.value.appendChild(iframe);

    // Handle iframe load event
    iframe.onload = () => {
      console.log("Power BI Report loaded successfully");
      isLoading.value = false;
    };

    iframe.onerror = () => {
      console.error("Power BI Report failed to load");
      hasError.value = true;
      isLoading.value = false;
    };
  } catch (error) {
    console.error("Error embedding Power BI report:", error);
    hasError.value = true;
    isLoading.value = false;
  }
};

const handleLoad = () => {
  isLoading.value = false;
};

const handleError = () => {
  isLoading.value = false;
  hasError.value = true;
};

onMounted(() => {
  if (isPowerBIReport.value) {
    embedPowerBIReport();
  } else {
    // For non-Power BI content, set loading to false so iframe shows
    isLoading.value = false;
  }
});

watch(
  () => props.link,
  () => {
    if (isPowerBIReport.value) {
      embedPowerBIReport();
    } else {
      isLoading.value = false;
      hasError.value = false;
    }
  }
);

onBeforeUnmount(() => {
  if (powerbiContainer.value) {
    powerbiContainer.value.innerHTML = "";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "spinner" }, null, -1),
            _createElementVNode("p", null, "Loading content...", -1)
          ])))
        : _createCommentVNode("", true),
      (hasError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
            _createElementVNode("p", null, "Failed to load content. Please try again.", -1)
          ])))
        : _createCommentVNode("", true),
      (isPowerBIReport.value && !isLoading.value && !hasError.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            ref_key: "powerbiContainer",
            ref: powerbiContainer,
            class: "powerbiReport"
          }, null, 512))
        : _createCommentVNode("", true),
      (!isPowerBIReport.value && !isLoading.value && !hasError.value)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 3,
            class: "powerbiReport",
            width: "100%",
            src: props.link,
            title: props.name || 'Embedded Content',
            frameborder: "0",
            allowfullscreen: "true",
            style: {"height":"calc(100vh - 100px)"},
            onLoad: handleLoad,
            onError: handleError
          }, null, 40, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})